export function parseNumericString(value: string, isFloat: boolean): number {
  return isFloat ? parseFloat(value) : parseInt(value, 10);
}
